import React, { useEffect, useState } from 'react';
import styles from './PlatformTimeLimit.module.scss';
import { $t } from "../../helpers/translator";
import Toggle from "../miscellaneous/Toggle/Toggle";
import Tooltip from '../miscellaneous/Tooltip/Tooltip';


import Loader from "../miscellaneous/Loader/Loader";
import moment from 'moment';
import { useSelector } from "react-redux";
import ChangeTimeLimit from './ChangeTimeLimit/ChangeTimeLimit';

export const checkIsUnlimited = (key, platform) => {
    return platform[ key ] && moment(platform[ key ]).year() >= 2099;
}

const PlatformTimeLimit = (props) => {
    const { platform, editPlatform, userType } = props;
    const timeLimitKey = userType === 5 ? 'time_limit_alma' : 'time_limit';
    const lastChange = userType === 5 ? platform?.time_limit_logs?.alma : platform?.time_limit_logs?.distributor;

    const user = useSelector(state => state.auth.user)

    const [ loading, setLoading ] = useState(false);
    const [ isUnlimited, setIsUnlimited ] = useState(checkIsUnlimited(timeLimitKey, platform));
    const [ timeLimit, setTimeLimit ] = useState(platform[ timeLimitKey ]);
    const [ updatedBy, setUpdatedBy ] = useState({
        user_name: lastChange?.user_name,
        last_change: lastChange?.last_change
    });
    const title = userType === 5 ? $t('global.users.admin') : $t('global.users.distributor');

    useEffect(() => {
        setIsUnlimited(checkIsUnlimited(timeLimitKey, platform));
        setTimeLimit(platform[ timeLimitKey ]);
    }, [ platform ])

    const ToggleWrapper = ({ children }) => {
        const isDisabled = userType === 4 && checkIsUnlimited('time_limit_alma', platform) === false;

        if (isDisabled) {
            return (
                <Tooltip content="Disabled by Alma Admin">
                    { children }
                </Tooltip>
            )
        }

        return children;
    }

    return (
        <div className={ styles.container }>
            { loading ?
                <div className={ styles.loaderContainer }>
                    <Loader />
                </div>
                :
                null }
            <div className={ styles.flexContainer }>
                <div className={ styles.padding }>
                    <div className={ styles.title }>
                        <h3>{ title }</h3>
                        <span>Time Limit</span>
                    </div>
                    <div className={ styles.row }>
                        {/* <label>Time Limit Status:</label> */ }
                        <div className={ styles.toggle }>
                            <ToggleWrapper>
                                <Toggle
                                    status={ isUnlimited }
                                    offText={ "Limited" }
                                    onText={ "Unlimited" }
                                    disabled={ userType === 4 && checkIsUnlimited('time_limit_alma', platform) === false ? true : false }
                                    onChange={ async (status) => {
                                        const newTimeLimit = status ? '2099-01-01' : moment().endOf('month').format('YYYY-MM-DD');
                                        const payload = {
                                            [ timeLimitKey ]: newTimeLimit
                                        };

                                        if (userType === 5 && checkIsUnlimited('time_limit', platform) === true && status === false) {
                                            payload[ 'time_limit' ] = moment().endOf('month').format('YYYY-MM-DD');
                                        }

                                        setIsUnlimited(status);
                                        setTimeLimit(newTimeLimit)
                                        setLoading(true);
                                        await editPlatform(platform, payload)
                                        setUpdatedBy({
                                            user_name: user?.name,
                                            last_change: moment().format('YYYY-MM-DD HH:mm:ss')
                                        });
                                        setLoading(false);
                                    } } />
                            </ToggleWrapper>
                        </div>
                    </div>

                    <div className={ styles.row }>
                        <label>Time Limit:</label>

                        <div className={ styles.rowValue }>
                            { isUnlimited && <span className={ styles.success }>Unlimited</span> }
                            { !isUnlimited && <>
                                { timeLimit }
                                <ChangeTimeLimit
                                    platform={ platform }
                                    userType={ userType }
                                    editPlatform={ editPlatform }
                                    setUpdatedBy={ setUpdatedBy }
                                />
                            </> }
                        </div>
                    </div>
                    <div className={ styles.row }>
                        <label>Updated By:</label>
                        <div className={ styles.rowValue }>
                            { updatedBy?.user_name !== undefined && <Tooltip key={ `${updatedBy?.last_change}-${updatedBy?.user_name}` } content={ `Updated at ${updatedBy?.last_change}` }>
                                <span>{ updatedBy?.user_name }</span>
                            </Tooltip> }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

PlatformTimeLimit.defaultProps = {
    platform: null,
}


export default PlatformTimeLimit;
